export default __webpack_public_path__ + "static/media/Pot2.817f1d77.svg";